(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('tfcCheckBoxCtrl', CheckBoxCtrl)
      .directive('tfcCheckBox', tfcCheckBox);

  function CheckBoxCtrl() {
    var vm = this;

    vm.stateClass = function () {

      if(vm.selected) {
        if(!vm.indeterminate) {
          return 'fa-check-square';
        } else {
          return 'fa-minus-square';
        }
      } else {
        return 'fa-square-o'
      }
    }
  }

  function tfcCheckBox() {
    return {
      restrict: 'E',
      bindToController : true,
      controller : 'tfcCheckBoxCtrl as vm',
      scope: {
        onChange: '&',
        selected: '=',
        indeterminate: '='
      },
      templateUrl: 'StandardReports/Util/CheckBox/CheckBox.tmpl.html'
    };
  }

})();
